<script setup lang="ts">
import { computed } from "@vue/reactivity";
import SpinnerSvg1 from "@/svgs/SpinnerSvg1.vue";

interface ButtonProps {
    buttonType?: "button" | "submit" | "reset";
    grow?: boolean;
    classes?: string;
    danger?: boolean;
    outline?: boolean;
    disabled?: boolean;
    primaryOutline?: boolean;
    loading?: boolean;
    link?: boolean;
    href?: string;
}

const props = withDefaults(defineProps<ButtonProps>(), {
    buttonType: "button",
    grow: false,
    classes: "",
    danger: false,
    outline: false,
    primaryOutline: false,
    disabled: false,
    loading: false,
    link:false,
    href:'',
});

const classes = computed<string>(() => {
    let className = "";
    if (props.grow) {
        className = `${className} w-full`;
    }
    if (props.danger || props.outline || props.primaryOutline) {
        if (props.danger) {
            className = `${className} bg-alert-red text-white border-alert-red   hover:border-[#cf2323] hover:bg-[#cf2323] `;
        }
        if (props.outline) {
            className = `${className} text-base-70 border-base-30 shadow-1 hover:bg-primary-100 hover:text-white hover:border-primary-100`;
        }
        if (props.primaryOutline) {
            className = `${className} text-primary-100 border-primary-100 shadow-1 hover:bg-primary-100 hover:text-white hover:border-primary-100`;
        }
    } else {
        className = `${className} text-white border-primary-100 shadow-1 bg-primary-100 hover:bg-white hover:text-primary-100`;
    }

    if (props.classes) {
        className = `${className} ${props.classes}`;
    }
    return className.trim();
});

const isDisabled = computed<boolean>(() => props.disabled || props.loading);

const emits = defineEmits<{
    (event: "buttonClicked"): void;
}>();

const emitElseSubmit = (): void => {
    if (props.buttonType !== "submit") {
        emits("buttonClicked");
    }
};
</script>

<template>

    <a v-if="props.link"
       :href="props.href"
       target="_blank"
       rel="noopener noreferrer nofollow"
       class="group rounded px-6 py-2.5 text-sm border font-medium transition-all"
       :class="classes"
>
    <slot></slot>
</a>

    <button v-else
        :type="props.buttonType"
        class="group rounded px-6 py-2.5 text-sm border font-medium transition-all items-center"
        :class="classes"
        @click="emitElseSubmit"
        :disabled="isDisabled"
    >
        <span class="inline-block mr-1" v-if="loading"><SpinnerSvg1 /> </span>
        <slot></slot>
    </button>

</template>
